document.addEventListener("DOMContentLoaded", () => {
  const carousel      = document.querySelector(".carousel");
  if (!carousel) return;

  const viewport      = carousel.querySelector(".carousel__viewport");
  const track         = carousel.querySelector(".carousel__track_reviews");
  const slides        = Array.from(carousel.querySelectorAll(".carousel__slide"));
  const controls      = carousel.querySelector(".carousel__controls");
  const prevBtn       = controls?.querySelector(".carousel__btn.prev") || controls?.querySelector(".carousel__btn:nth-child(1)");
  const nextBtn       = controls?.querySelector(".carousel__btn.next") || controls?.querySelector(".carousel__btn:nth-child(2)");
  const dotsWrap      = carousel.querySelector(".carousel__dots");
  const dots          = dotsWrap ? Array.from(dotsWrap.querySelectorAll(".carousel__dot")) : [];

  let index = 0;
  let slidesPerView = 1;   
  let step = 0;
  let autoplayInterval = null;
  const autoplayDelay = 3000; // 3 seconds

  function getNumber(val) {
    const n = parseFloat(val);
    return isNaN(n) ? 0 : n;
  }

  function measure() {
    slidesPerView = window.matchMedia("(max-width: 768px)").matches ? 1 : 3;

    const slideRect = slides[0].getBoundingClientRect();
    const slideWidth = slideRect.width;

    const cs = getComputedStyle(track);
    const gap = getNumber(cs.gap);

    step = slideWidth + gap;

    const maxIndex = Math.max(0, slides.length - slidesPerView);
    if (index > maxIndex) index = maxIndex;

    apply();
    updateUi();
  }

  function apply() {
    const x = -(index * step);
    track.style.transform = `translateX(${x}px)`;
    updateCenterClass();
  }

  function updateUi() {
    const maxIndex = Math.max(0, slides.length - slidesPerView);
    if (prevBtn) prevBtn.disabled = (index <= 0);
    if (nextBtn) nextBtn.disabled = (index >= maxIndex);

    if (dots.length) {
      dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
    }
  }

  function updateCenterClass() {
    slides.forEach(s => s.classList.remove("is-center"));
    const start = index;
    const mid = start + Math.floor(slidesPerView / 2);
    if (slides[mid]) slides[mid].classList.add("is-center");
  }

  function goNext() {
    const maxIndex = Math.max(0, slides.length - slidesPerView);
    if (index < maxIndex) {
      index++;
    } else {
      // Loop back to start
      index = 0;
    }
    apply();
    updateUi();
  }

  function goPrev() {
    if (index > 0) {
      index--;
    } else {
      // Loop to end
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      index = maxIndex;
    }
    apply();
    updateUi();
  }

  // Autoplay functions
  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(goNext, autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Hook up arrows
  nextBtn && nextBtn.addEventListener("click", () => {
    goNext();
    stopAutoplay();
    startAutoplay(); // Restart autoplay after manual interaction
  });

  prevBtn && prevBtn.addEventListener("click", () => {
    goPrev();
    stopAutoplay();
    startAutoplay(); // Restart autoplay after manual interaction
  });

  // Dots click
  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      index = i;
      apply();
      updateUi();
      stopAutoplay();
      startAutoplay(); // Restart autoplay after manual interaction
    });
  });

  // Pause on hover
  carousel.addEventListener("mouseenter", stopAutoplay);
  carousel.addEventListener("mouseleave", startAutoplay);

  // Pause on touch (mobile)
  carousel.addEventListener("touchstart", stopAutoplay);
  carousel.addEventListener("touchend", () => {
    setTimeout(startAutoplay, 1000); // Resume after 1 second
  });

  let rAF;
  const onResize = () => {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(measure);
  };
  window.addEventListener("resize", onResize);
  window.addEventListener("load", measure);

  measure();
  startAutoplay(); // Start autoplay on load
});